import { render, staticRenderFns } from "./TheNavbarVertical.vue?vue&type=template&id=3b64fbff&scoped=true"
import script from "./TheNavbarVertical.vue?vue&type=script&lang=js"
export * from "./TheNavbarVertical.vue?vue&type=script&lang=js"
import style0 from "./TheNavbarVertical.vue?vue&type=style&index=0&id=3b64fbff&prod&scoped=true&lang=css"
import style1 from "./TheNavbarVertical.vue?vue&type=style&index=1&id=3b64fbff&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b64fbff",
  null
  
)

export default component.exports